import {Component, Input, ViewEncapsulation} from '@angular/core';
import {ItemType} from 'src/app/model/item-type';
import {EventItemType} from "@model";

@Component({
  selector: 'app-carousel',
  templateUrl: './carousel.component.html',
  styleUrls: ['./carousel.component.scss'],
})
export class CarouselComponent {
  @Input() images: string[] | undefined;
  @Input() bannerImage: string | undefined;
  @Input() bannerAlt: string | undefined;
  @Input() imageAlt: string | undefined;
  @Input() showButton: boolean = false;
  @Input() showGradient: boolean = false;

}
